import React, {FC, useState} from 'react';
import  './index.scss';
import {Button, Dropdown, Menu, Select} from "antd";
import {o,
    ArrowDownIco,
    PdfIco,
    XlsIco
} from "../../../../modules/CustomIcons";
import Icon from "@ant-design/icons";
import {Link} from "react-router-dom";



interface DataConvertProps {
    className?: string;
    onClickPdf?: (lang:any) => void, 
    onClickExcel?: (lang:any) => void,
    loadingExcel?:boolean
    loadingPdf?:boolean
}


export const DataConvert: FC<DataConvertProps> = ({onClickExcel, onClickPdf, className,loadingPdf,loadingExcel}) => {

    const [lang, setLang] = useState<any>("AZ");
  const selectOptions = ['AZ', 'EN', 'RU']

    const tableDropDown=(
       
                   <div
                                       className="pagination-selector language-selector"
                                       style={{ left: '0px' }}
                                     >
                                       <Select
                                         // open={true}
                                         defaultValue={'AZ'}
                                         placeholder="AZ"
                                         onChange={(value: any) => setLang(value)}
                                         // width={64}
                                       >
                                         {selectOptions.map((item) => {
                                           return <option value={item}>{item}</option>
                                         })}
                                       </Select>
                                     </div>
                
    );


    return (
        <div className={`dataConvert ${className}`}>
            {/* <Dropdown overlay={tableDropDown} trigger={'click'} defaultValue={lang}  placement="bottomRight"  className={'test'}/> */}
           {tableDropDown}
            <div style={{marginLeft: 40,display:'flex',gap:6}}>
                <Button style={{display:'flex'}} loading={loadingPdf} icon={<PdfIco/>} className='dataConvert__btn'  onClick={()=> onClickPdf?.(lang)}>
                    {/* <PdfIco/> */}
                </Button>
                <Button style={{display:'flex'}} loading={loadingExcel} icon={<XlsIco/>} className='dataConvert__btn' onClick={()=>onClickExcel?.(lang)}>
                    {/* {!loadingExcel && <XlsIco/>} */}
                </Button>
            </div>
        </div>
    );
};
